import React, { PropsWithChildren } from 'react';
import Grid from '@mui/material/Grid2';
import { ICategory } from '../../../../dataObjects/models/categories/Category';
import { CategoriesCardGridViewItem } from './CategoriesCardGridViewItem';
import { ICategoryViewModel } from '../../../../dataObjects/viewModels/categoryViewModel';


export interface ICategoriesCardGridViewProps extends PropsWithChildren<unknown> {
  categoryViewModels: Array<ICategoryViewModel>;
  onDelete: (category: ICategory) => void;
  onDeleteProfileImage: (categoryViewModel: ICategoryViewModel) => void;
}


export const CategoriesCardGridView: React.FC<ICategoriesCardGridViewProps> = (props: ICategoriesCardGridViewProps) => {
  CategoriesCardGridView.displayName = 'Categories Card Grid View';

  // eslint-disable-next-line no-console
  // console.info(`Render CategoriesList`);

  const { categoryViewModels, onDelete, onDeleteProfileImage } = props;

  return (
    <>
      <Grid container spacing={2} >
        {
          categoryViewModels.map(categoryViewModel =>
            <Grid key={categoryViewModel.category.id} size={{ xs: 12, sm: 6, md: 4, lg: 2, xl: 2 }} alignItems={'stretch'} alignContent={'stretch'}>
              <CategoriesCardGridViewItem categoryViewModel={categoryViewModel} onDelete={onDelete} onDeleteProfileImage={onDeleteProfileImage} />
            </Grid>
          )
        }
      </Grid>
    </>
  );

}